export default function MemberUserCtrl($scope, UserService, $mdSidenav, $timeout, $rootScope) {
  UserService.subject.safeApply($scope, function (user) {
    $scope.user = user;
  }).subscribe();


  $scope.forceUnlock = false;

  // Listen for global "force close" requests
  const un = $rootScope.$on('sidenav:forceClose', (e, id = 'left') => {
    $scope.forceUnlock = true;                  // disable locked-open
    $timeout(() => $mdSidenav(id).close());
  });

  const un2 = $rootScope.$on('sidenav:forceOpen', (e, id = 'left') => {
    $scope.forceUnlock = false;
    $timeout(() => $mdSidenav(id).open());
  });

  // Clean up
  this.$onDestroy = un;
  this.$onDestroy = un2;

}
